module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "columns is-multiline",
    attrs: {
      "id": "colors"
    }
  }, _vm._l((_vm.colorVars), function(color) {
    return _c('div', {
      staticClass: "column is-4"
    }, [_c('div', {
      staticClass: "colors",
      class: 'is-' + color.name
    }, [_c('h2', [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('p', [_vm._v("Variable: "), _c('code', {
      staticClass: "html"
    }, [_vm._v(_vm._s(color.var))])]), _vm._v(" "), _c('p', [_vm._v("Invert: "), _c('code', {
      staticClass: "html"
    }, [_vm._v(_vm._s(color.invert))])])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7652c016"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/colors/Colors.vue
// module id = 90
// module chunks = 0